const CharsUtil = {
    FaToEn : (string) => {
        return string.replace('۰','0')
                     .replace('۱','1')
                     .replace('۲','2')
                     .replace('۳','3')
                     .replace('۴','4')
                     .replace('۵','5')
                     .replace('۶','6')
                     .replace('۷','7')
                     .replace('۸','8')
                     .replace('۹','9');
    },
    replaceAll : (string, search, replace) => {
        return string.split(search).join(replace);
    }
};

export default CharsUtil;